import React, { type ReactNode } from "react";
import { Text, Flex, type FlexProps } from "@chakra-ui/react";
import { ChevronRightIcon } from "ui/icons";

function Heading({ children }: { children: ReactNode }) {
  return (
    <Text fontSize="13px" fontWeight="bold">
      {children}
    </Text>
  );
}

function Value({ amount, unit }: { amount: string; unit: string }) {
  return (
    <Flex bg="rgba(255, 255, 255, 0.10)" borderRadius="md" fontSize="13px" lineHeight="20px" gap={1} px={1}>
      <Text as="span" fontWeight="semibold">
        {amount}
      </Text>
      <Text as="span" color="product.gray.300">
        {unit}
      </Text>
    </Flex>
  );
}

type TooltipProps = {
  color?: string;
  heading?: string;
};

export function Tooltip({ color = "grass", heading = "Drop-off", children, ...props }: TooltipProps & FlexProps) {
  return (
    <Flex
      bg="product.gray.900"
      borderRadius="md"
      boxShadow="xs"
      color="white"
      fontFamily="inter"
      gap={2}
      p={2}
      pos="relative"
      {...props}
    >
      <Flex bg={color} borderRadius="md" w="4px" />

      <Flex align="start" direction="column" gap={1}>
        <Heading>{heading}</Heading>

        <Value amount="68%" unit="drop off" />
        <Value amount="200" unit="unique customers" />

        <Text id="funnels-tooltip-link" color="product.gray.300" fontSize="xs" lineHeight="16px" pos="relative">
          Sync audience
          <ChevronRightIcon id="funnels-tooltip-chevron" pos="absolute" right={-4} top="2.5px" boxSize={3} />
        </Text>
      </Flex>
    </Flex>
  );
}
